<template>
  <div>
    <v-app-bar
      class="ukpl-main-navigation"
      v-if="currentUser"
      dense
      color="#0072ff"
      dark
      elevate-on-scroll
    >
      <div class="ukpl-main-navigation-container">
        <div class="navigation-left-wrap">
          <a href="https://www.ukpl.co.uk">
            <v-img
              src="@/assets/ukpl-logo-new.png"
              alt="UKPL logo"
              contain
              class="ukpl-nav-logo"
            />
          </a>
          <!-- Slot for additional actions in the toolbar (e.g., Save, Change Password) -->
          <slot name="actions"></slot>
        </div>
        <v-spacer></v-spacer>

        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn color="#0072ff" depressed to="/team">
            <v-icon class="mr-2">fa-users</v-icon>Teams
          </v-btn>
          <v-btn v-if="hasTeams" color="#0072ff" depressed to="/roster">
            <v-icon class="mr-2">fa-list</v-icon>Roster
          </v-btn>
          <v-btn color="#0072ff" depressed to="/profile">
            <v-icon class="mr-2">fa-user</v-icon>Profile
          </v-btn>
          <v-btn color="#0072ff" depressed to="/disclaimer">
            <v-icon class="mr-2">fa-file-signature</v-icon>Disclaimer
          </v-btn>
          <v-btn color="#0072ff" depressed to="/idcard">
            <v-icon class="mr-2">far fa-id-card</v-icon>ID Card
          </v-btn>
          <v-btn color="#0072ff" depressed @click="logOut">
            <v-icon class="mr-2">fa-sign-out-alt</v-icon>LogOut
          </v-btn>
        </v-toolbar-items>
      </div>

      <v-toolbar-items class="hidden-md-and-up">
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item-group>
          <!-- Slot for additional drawer items at the top -->
          <slot name="drawer-top"></slot>

          <v-list-item key="team" to="/team">
            <v-list-item-icon><v-icon>fa-users</v-icon></v-list-item-icon>
            <v-list-item-title>Teams</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="hasTeams" key="roster" to="/roster">
            <v-list-item-icon><v-icon>fa-list</v-icon></v-list-item-icon>
            <v-list-item-title>Roster</v-list-item-title>
          </v-list-item>
          <v-list-item key="profile" to="/profile">
            <v-list-item-icon><v-icon>fa-user</v-icon></v-list-item-icon>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item key="disclaimer" to="/disclaimer">
            <v-list-item-icon>
              <v-icon>fa-file-signature</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Disclaimer</v-list-item-title>
          </v-list-item>
          <v-list-item key="id-card" to="/idcard">
            <v-list-item-icon>
              <v-icon>far fa-id-card</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ID Card</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logOut" key="logout">
            <v-list-item-icon>
              <v-icon>fa-sign-out-alt</v-icon>
            </v-list-item-icon>
            <v-list-item-title>LogOut</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import UserService from "../services/user.service";

export default {
  name: "AppNavigation",
  data: () => ({
    drawer: false,
    currentCaptain: false,
    hasTeams: false,
  }),
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_ADMIN");
      }
      return false;
    },
  },
  methods: {
    logOut() {
      console.log("logging out");
      this.$store.dispatch("auth/logout");
      this.$router.push("/home");
    },
    isCaptain() {
      UserService.getCaptainedTeams().then(
        (response) => {
          if (response.data && response.data.length > 0) {
            this.currentCaptain = true;
          } else {
            this.currentCaptain = false;
          }
        },
        (error) => {
          console.error(error);
          this.currentCaptain = false;
        }
      );
    },
    checkTeams() {
      UserService.getUserTeams().then(
        (response) => {
          if (response.data && response.data.length > 0) {
            this.hasTeams = true;
          } else {
            this.hasTeams = false;
          }
        },
        (error) => {
          console.error(error);
          this.hasTeams = false;
        }
      );
    },
  },
  mounted() {
    if (this.currentUser) {
      this.isCaptain();
      this.checkTeams();
    }
  },
};
</script>
